/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PaymentsRouteImport } from './routes/payments'
import { Route as PaymentRouteImport } from './routes/payment'
import { Route as PayRentRouteImport } from './routes/pay-rent'
import { Route as LoginRouteImport } from './routes/login'
import { Route as EmailCallbackRouteImport } from './routes/email-callback'
import { Route as CheckInboxRouteImport } from './routes/check-inbox'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RewardsIndexRouteImport } from './routes/rewards/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as RewardsHistoryRouteImport } from './routes/rewards/history'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminRewardsRouteImport } from './routes/admin/rewards'
import { Route as AdminRewardRulesRouteImport } from './routes/admin/reward-rules'
import { Route as AdminRewardPointsRouteImport } from './routes/admin/reward-points'
import { Route as AdminCouponsRouteImport } from './routes/admin/coupons'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsRoute = PaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentRoute = PaymentRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => rootRouteImport,
} as any)
const PayRentRoute = PayRentRouteImport.update({
  id: '/pay-rent',
  path: '/pay-rent',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailCallbackRoute = EmailCallbackRouteImport.update({
  id: '/email-callback',
  path: '/email-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckInboxRoute = CheckInboxRouteImport.update({
  id: '/check-inbox',
  path: '/check-inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RewardsIndexRoute = RewardsIndexRouteImport.update({
  id: '/rewards/',
  path: '/rewards/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const RewardsHistoryRoute = RewardsHistoryRouteImport.update({
  id: '/rewards/history',
  path: '/rewards/history',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRewardsRoute = AdminRewardsRouteImport.update({
  id: '/admin/rewards',
  path: '/admin/rewards',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRewardRulesRoute = AdminRewardRulesRouteImport.update({
  id: '/admin/reward-rules',
  path: '/admin/reward-rules',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRewardPointsRoute = AdminRewardPointsRouteImport.update({
  id: '/admin/reward-points',
  path: '/admin/reward-points',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCouponsRoute = AdminCouponsRouteImport.update({
  id: '/admin/coupons',
  path: '/admin/coupons',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/check-inbox': typeof CheckInboxRoute
  '/email-callback': typeof EmailCallbackRoute
  '/login': typeof LoginRoute
  '/pay-rent': typeof PayRentRoute
  '/payment': typeof PaymentRoute
  '/payments': typeof PaymentsRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/settings': typeof SettingsRoute
  '/admin/coupons': typeof AdminCouponsRoute
  '/admin/reward-points': typeof AdminRewardPointsRoute
  '/admin/reward-rules': typeof AdminRewardRulesRoute
  '/admin/rewards': typeof AdminRewardsRoute
  '/admin/users': typeof AdminUsersRoute
  '/rewards/history': typeof RewardsHistoryRoute
  '/admin/': typeof AdminIndexRoute
  '/rewards/': typeof RewardsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/check-inbox': typeof CheckInboxRoute
  '/email-callback': typeof EmailCallbackRoute
  '/login': typeof LoginRoute
  '/pay-rent': typeof PayRentRoute
  '/payment': typeof PaymentRoute
  '/payments': typeof PaymentsRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/settings': typeof SettingsRoute
  '/admin/coupons': typeof AdminCouponsRoute
  '/admin/reward-points': typeof AdminRewardPointsRoute
  '/admin/reward-rules': typeof AdminRewardRulesRoute
  '/admin/rewards': typeof AdminRewardsRoute
  '/admin/users': typeof AdminUsersRoute
  '/rewards/history': typeof RewardsHistoryRoute
  '/admin': typeof AdminIndexRoute
  '/rewards': typeof RewardsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/check-inbox': typeof CheckInboxRoute
  '/email-callback': typeof EmailCallbackRoute
  '/login': typeof LoginRoute
  '/pay-rent': typeof PayRentRoute
  '/payment': typeof PaymentRoute
  '/payments': typeof PaymentsRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/settings': typeof SettingsRoute
  '/admin/coupons': typeof AdminCouponsRoute
  '/admin/reward-points': typeof AdminRewardPointsRoute
  '/admin/reward-rules': typeof AdminRewardRulesRoute
  '/admin/rewards': typeof AdminRewardsRoute
  '/admin/users': typeof AdminUsersRoute
  '/rewards/history': typeof RewardsHistoryRoute
  '/admin/': typeof AdminIndexRoute
  '/rewards/': typeof RewardsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/check-inbox'
    | '/email-callback'
    | '/login'
    | '/pay-rent'
    | '/payment'
    | '/payments'
    | '/profile'
    | '/register'
    | '/settings'
    | '/admin/coupons'
    | '/admin/reward-points'
    | '/admin/reward-rules'
    | '/admin/rewards'
    | '/admin/users'
    | '/rewards/history'
    | '/admin/'
    | '/rewards/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/check-inbox'
    | '/email-callback'
    | '/login'
    | '/pay-rent'
    | '/payment'
    | '/payments'
    | '/profile'
    | '/register'
    | '/settings'
    | '/admin/coupons'
    | '/admin/reward-points'
    | '/admin/reward-rules'
    | '/admin/rewards'
    | '/admin/users'
    | '/rewards/history'
    | '/admin'
    | '/rewards'
  id:
    | '__root__'
    | '/'
    | '/check-inbox'
    | '/email-callback'
    | '/login'
    | '/pay-rent'
    | '/payment'
    | '/payments'
    | '/profile'
    | '/register'
    | '/settings'
    | '/admin/coupons'
    | '/admin/reward-points'
    | '/admin/reward-rules'
    | '/admin/rewards'
    | '/admin/users'
    | '/rewards/history'
    | '/admin/'
    | '/rewards/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CheckInboxRoute: typeof CheckInboxRoute
  EmailCallbackRoute: typeof EmailCallbackRoute
  LoginRoute: typeof LoginRoute
  PayRentRoute: typeof PayRentRoute
  PaymentRoute: typeof PaymentRoute
  PaymentsRoute: typeof PaymentsRoute
  ProfileRoute: typeof ProfileRoute
  RegisterRoute: typeof RegisterRoute
  SettingsRoute: typeof SettingsRoute
  AdminCouponsRoute: typeof AdminCouponsRoute
  AdminRewardPointsRoute: typeof AdminRewardPointsRoute
  AdminRewardRulesRoute: typeof AdminRewardRulesRoute
  AdminRewardsRoute: typeof AdminRewardsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  RewardsHistoryRoute: typeof RewardsHistoryRoute
  AdminIndexRoute: typeof AdminIndexRoute
  RewardsIndexRoute: typeof RewardsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments': {
      id: '/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof PaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment': {
      id: '/payment'
      path: '/payment'
      fullPath: '/payment'
      preLoaderRoute: typeof PaymentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pay-rent': {
      id: '/pay-rent'
      path: '/pay-rent'
      fullPath: '/pay-rent'
      preLoaderRoute: typeof PayRentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email-callback': {
      id: '/email-callback'
      path: '/email-callback'
      fullPath: '/email-callback'
      preLoaderRoute: typeof EmailCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/check-inbox': {
      id: '/check-inbox'
      path: '/check-inbox'
      fullPath: '/check-inbox'
      preLoaderRoute: typeof CheckInboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rewards/': {
      id: '/rewards/'
      path: '/rewards'
      fullPath: '/rewards/'
      preLoaderRoute: typeof RewardsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rewards/history': {
      id: '/rewards/history'
      path: '/rewards/history'
      fullPath: '/rewards/history'
      preLoaderRoute: typeof RewardsHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/rewards': {
      id: '/admin/rewards'
      path: '/admin/rewards'
      fullPath: '/admin/rewards'
      preLoaderRoute: typeof AdminRewardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reward-rules': {
      id: '/admin/reward-rules'
      path: '/admin/reward-rules'
      fullPath: '/admin/reward-rules'
      preLoaderRoute: typeof AdminRewardRulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reward-points': {
      id: '/admin/reward-points'
      path: '/admin/reward-points'
      fullPath: '/admin/reward-points'
      preLoaderRoute: typeof AdminRewardPointsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/coupons': {
      id: '/admin/coupons'
      path: '/admin/coupons'
      fullPath: '/admin/coupons'
      preLoaderRoute: typeof AdminCouponsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CheckInboxRoute: CheckInboxRoute,
  EmailCallbackRoute: EmailCallbackRoute,
  LoginRoute: LoginRoute,
  PayRentRoute: PayRentRoute,
  PaymentRoute: PaymentRoute,
  PaymentsRoute: PaymentsRoute,
  ProfileRoute: ProfileRoute,
  RegisterRoute: RegisterRoute,
  SettingsRoute: SettingsRoute,
  AdminCouponsRoute: AdminCouponsRoute,
  AdminRewardPointsRoute: AdminRewardPointsRoute,
  AdminRewardRulesRoute: AdminRewardRulesRoute,
  AdminRewardsRoute: AdminRewardsRoute,
  AdminUsersRoute: AdminUsersRoute,
  RewardsHistoryRoute: RewardsHistoryRoute,
  AdminIndexRoute: AdminIndexRoute,
  RewardsIndexRoute: RewardsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
